module.exports = "/_next/static/images/slide5-ead2645d6c9083626abbb54402c45b39.jpg.webp";